module.exports = __webpack_public_path__ + "img/asynchronized-learning.72e0bba3.png";